import { useFeaturesTagsQuery, useCalculatedVariablesByAssetId } from 'queries/features/queries';
import { CalculatedVariable, FeatureTags } from 'queries/features/types';
import { useMemo } from 'react';
import { parseFeaturesTags } from '../helper';

const isCalculatedVariable = (
  tagsData: FeatureTags['features'] | CalculatedVariable[],
): tagsData is CalculatedVariable[] => tagsData.length > 0 && 'calculated_variable' in tagsData[0];

export const useFeaturesTags = (assetId: string, modelName?: string) => {
  const tagsByEventQuery = useFeaturesTagsQuery(modelName, {
    enabled: !!modelName,
  });
  const tagsByAssetQuery = useCalculatedVariablesByAssetId(assetId, {
    enabled: !modelName,
  });

  const tagsData = modelName
    ? tagsByEventQuery.data?.features ?? []
    : tagsByAssetQuery.data?.calculated_variables ?? [];

  const tags: Array<ChartTag & { tooltipText?: string }> = useMemo(() => {
    return isCalculatedVariable(tagsData)
      ? parseFeaturesTags(tagsData as CalculatedVariable[])
      : (tagsData.map((tag) => ({
          ...tag,
          category: [],
          tooltipText: tag.description,
          reference: tag.reference,
        })) as Array<ChartTag & { tooltipText?: string }>);
  }, [tagsData]);

  return { tags, isLoading: tagsByEventQuery.isFetching || tagsByAssetQuery.isFetching };
};

export default useFeaturesTags;
